import {useCallback, useEffect, useState} from "react";
import {getHeaderSettings, updateHeaderSettings} from "../../../services/settings";


export function useHeaderSettings() {
  const [settings, setSettings] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => {
    try {
      setIsLoading(true);
      setSettings(await getHeaderSettings());
    } catch (err) {
      setError({
        message: err.message,
        title: "Failed to fetch header settings"
      });
    } finally {
      setIsLoading(false);
    }
  }, []);


  const save = async (data) => {
    try {
      setIsLoading(true);
      console.log(data);
      setSettings(await updateHeaderSettings(data));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {save, isLoading, settings, error};
}